var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-deliverables-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var brief = ref.brief;
var task = ref.task;
var isLoading = ref.isLoading;
var errors = ref.errors;
var errorMessage = ref.errorMessage;
var onPageClose = ref.onPageClose;
var deliverables = ref.deliverables;
var onBack = ref.onBack;
return [_c('activation-deliverables-view',{attrs:{"brief":brief,"task":task,"is-loading":isLoading,"errors":errors,"error-message":errorMessage,"deliverables":deliverables},on:{"close":onPageClose,"back":onBack}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }